import { useDispatch, useSelector } from "react-redux";
import { type RootState } from "~/app/store";
import { selectProductDescriptor } from "~/domains/product/redux/selectors";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { isPackageRestrictionEnabled } from "~/features/PackageRestriction/utils/isPackageRestrictionEnabled";
import { selectPackageBasedOnQuery } from "~/utils/cartHelper";
import { addMessage } from "~/features/toasts/redux/actions";

export const useCalculateRestrictedCode = (query: string, productCode: string) => {
  const productDescriptor = useSelector((state: RootState) =>
    selectProductDescriptor(state, { productCode, priceReference: "" }),
  );

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const restrictedCode = useMemo(() => {
    if (!isPackageRestrictionEnabled()) {
      return null;
    }

    if (!productDescriptor.availability) {
      return null;
    }
    const restrictedPackage = selectPackageBasedOnQuery(query)(productDescriptor.availability, productDescriptor.base);
    if (!restrictedPackage) {
      if (query.replace(/-/g, "").length === 15) {
        dispatch(addMessage("info", t("restrictedPackaging.notFound")));
      }
      return null;
    }
    return restrictedPackage.packCode;
  }, [productDescriptor.availability, productDescriptor.base, query]);

  return restrictedCode;
};
